// extracted by mini-css-extract-plugin
export var heroImage = "_i7-1";
export var modal = "_i7-0";